import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  AdminApiPaths,
  TApiResponse,
  APIDataProvider,
  TApiPaginationResponse,
} from '../../../api';
import { INotificationLog } from '.';

export type TAdminGetNotificationLog = {
  limit: number;
  offset: number;
  sortKey?: string;
  sortValue?: number;
  type?: string;
  channel?: string;
  user?: string;
  searchText?: string;
};

const apiDataProvider = new APIDataProvider();

const adminGetNotificationLogsModule = async ({
  limit,
  offset,
  sortKey,
  sortValue,
  type,
  channel,
  user,
  searchText,
}: TAdminGetNotificationLog) => {
  let path = `${AdminApiPaths.notificationLogs}?limit=${limit}&offset=${offset}`;

  if (sortKey) {
    path += `&sortKey=${sortKey}`;
  }

  if (sortKey) {
    path += `&sortValue=${sortValue}`;
  }

  if (type) {
    path += `&type=${type}`;
  }

  if (channel) {
    path += `&channel=${channel}`;
  }

  if (user) {
    path += `&user=${user}`;
  }

  if (searchText) {
    path += `&searchText=${encodeURIComponent(searchText)}`;
  }

  const response = await apiDataProvider.get<
    TApiResponse<TApiPaginationResponse<INotificationLog>>
  >(path);

  return response.data;
};

export const adminGetNotificationLogs = createAsyncThunk(
  '/admin/notification-logs/list',
  adminGetNotificationLogsModule
);
